import React from 'react';
import StaffForm from '../../Components/Staff/StaffForm';

export default function DoctorForm() {
  return (
    <StaffForm
      role="doctor"
      title="Doctor"
      returnUrl="/doctors"
    />
  );
}
